// importeer hier alle scripts die je maakt

import "./utils/favicon.js";
import "./utils/boxSizing.js";
import "./alpine/alpine.js";
import "./components/lenis.js";
import "./animations/animations.js";
import "./components/swiper.js";
import "./components/water-animation.js";
import "./components/countup.js";
import "./components/leaflet-map.js";
import "./components/language-switcher.js";
import "./components/rail.js";
import "./vendor/recaptcha.js";
import "./vendor/ga-slug.js";
import "./helpers/lazyImgs.js";
import "./helpers/lazy-video.js";

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {});
Fancybox.bind("[data-fancybox='gallery']", {});
